import { AfterViewInit, ChangeDetectionStrategy, Component,ElementRef,Input, OnInit, ViewChild, AfterViewChecked, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ChangeDetectorRef, AfterContentChecked } from '@angular/core'
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { DhlFormControlEventData } from '../../dhl-form/models/dhl-form-control-event-data';
import { DhlFormControlEvent } from '../../dhl-form/models/dhl-form-control-event';
import { DomEventService } from 'src/app/common/dom-event/dom-event.service';
import {TranslateService} from '@ngx-translate/core';
import  {Constant}  from '../../constants/constants';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { SelectionModel } from '@angular/cdk/collections';
import { CoxService } from 'src/app/app-business-object-module/cox.service';
import { DatePipe } from '@angular/common';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import {Clipboard} from '@angular/cdk/clipboard';
import { APP_Constants } from 'src/app/app.constant';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import moment from 'moment';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';


@Component({
    selector: 'app-generic-table-v2',
    templateUrl: './generic-table-v2.component.html',
    styleUrls: ['./generic-table-v2.component.scss'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericTableV2Component implements OnInit, AfterViewInit, OnDestroy {

  @Input() configData;
  @Input() tableData;
  @Input() frmGroup;
  checkedBool =false;
  checkedIds:number[] =[];
  checkedItems: any[] = [];
  hide = false;
  isColumnOrderOpened = false;
  isColumnOrderClicked = false;
  iconDetails:any[];
  enum=Constant
  rowDataSelect: any;
  selectionArrayForSelectAll:any= [];
  clickEventSubscription: Subscription;
  scrollTopValue = 0;
  similarSelected = false;
  selection = new SelectionModel<any>(true, []);
  commonSubject;
  multiRowEvent : any;
  singleRowEvent : any;
  totalRecordsCount: any;
  shipStatus : boolean = false;
  private valueChangesSub: Subscription;
  templateData: any;
  orderFormSubmitted;
  editField: boolean;
  selfServiceConfig: boolean = false;
  orderForm: any;
  setStatusDetails(){
    if(this.tableRows){
      this.popupOptions = [];
      this.popupMarOptions = [];
      this.tableRows.forEach(item => {
        let status = item["status"];
        //CP-2724
        if (this.configData['popupSpace']) {
          status = this.apiService.separatePascalCase(status);
          this.getStatusWithSpace(item,status);  //CP-6447
          //item['statusWithSpace'] = status;
          item['STATUS'] = status;
          let statusIndex;
          this.tHeaders.forEach((thead, i) =>{
            if(thead.title === 'STATUS'){
              statusIndex = i;
              return;
            }
          })
            if (this.tHeaders[statusIndex] && this.tHeaders[statusIndex].statusSucessBorder && this.tHeaders[statusIndex].statusSucessBorder.includes(item["status"])) {
              item["className"] = 'dhl-type-' + item["TypeText"] + '-green-bordered-v2';
            } else if (this.tHeaders[statusIndex] && this.tHeaders[statusIndex].statusFailedBorder && this.tHeaders[statusIndex].statusFailedBorder.includes(item["status"])) {
              item["className"] = 'dhl-type-' + item["TypeText"] + '-bordered-v2';
            } else {
              item["className"] = 'dhl-type-' + item["TypeText"] + '-v2';
              //Cp-5592 - start
              if (item["status"]?.toLowerCase() == "delivered") {
                item["className"] = 'dhl-type-' + "Del" + '-v2';
              }
              //Cp-5592 - end
              //Cp-8790 - start Delivery Confirmed,Pending Acceptance,Planning Failed
           
              
              if(item["status"] == "EnrichmentOnHold" || item["status"] == "VerificationOnHold" || item["status"] == "OnHold"){
                item["className"] = 'dhl-type-' + item["TypeText"] + '-DottedLine';
              }
              if (item["status"] == "DeliveryConfirmed") {
                item["className"] = 'dhl-ptype-' + "DelCon" + '-v3';
              }
              if (item["status"] == "PendingAcceptance") {
                item["className"] = 'dhl-ptype-' + "PA" + '-v3';
              }
              if (item["status"] == "PlanningFailed") {
                item["className"] = 'dhl-type-PF-bordered-v2';
              }
              if (item["status"] == "InTransit") {
                item["className"] = 'dhl-ptype-' + "IT" + '-v3';
              }
              if (item["status"] == "Dispatched") {
                item["className"] = 'dhl-type-DISP-bordered-v2';
              }
              if (item["status"] == "ShipmentNotStarted") {
                item["className"] = 'dhl-type-sns-bordered-v2';
              }
              //Cp-8790 - end
            }
             //Data Upload listing status start
             if (item["status"] == "FAILED") {
              item["className"] = 'dhl-type-failed-v2 dhl-data-upload-status';
            }
            if (item["status"] == "SUCCESS") {
              item["className"] = 'dhl-type-success-v2 dhl-data-upload-status';
            }
            if (item["status"] == "IN PROGRESS") {
              item["className"] = 'dhl-type-IP-v2 dhl-data-upload-status';
            }
            if (item["status"] == "CODE ERROR") {
              item["className"] = 'dhl-type-CE-v2 dhl-data-upload-status';
            }
            if (item["status"] == "FRESH") {
              item["className"] = 'dhl-type-FR-v2 dhl-data-upload-status';
            }
            if (item["status"] == "STAGED") {
              item["className"] = 'dhl-type-IP-v2 dhl-data-upload-status';
            }
            if (item["status"] == "STARTED") {
              item["className"] = 'dhl-type-STR-v2 dhl-data-upload-status';
            }
            if (item["status"] == "NOT-STARTED") {
              item["className"] = 'dhl-type-notstarted-v2 dhl-data-upload-status';
            }
            if (item["status"] == "UNKNOWN") {
              item["className"] = 'dhl-type-unknown-v2 dhl-data-upload-status';
            }
            if (item["status"] == "ON HOLD") {
              item["className"] = 'dhl-type-onhold-v2 dhl-data-upload-status';
            }
            if (item["status"] == "ON HOLD RELEASE") {
              item["className"] = 'dhl-type-onholdrelease-v2 dhl-data-upload-status';
            }
            //Data Upload listing end
        }
        //end
        // if (!this.popupOptions.includes(status)) {
        //   this.popupOptions.push(status);
        // }
        if (!this.popupMarOptions.includes(item["STATUS_VALUE_XID"])) {
          if(item["STATUS_VALUE_XID"])
          this.popupMarOptions.push(item["STATUS_VALUE_XID"]);
        }
        if(!this.popupMarOptions.includes(item["STATUS#"])){
          if(item["STATUS#"])
          this.popupMarOptions.push(item["STATUS#"]);
        }
        if(!this.popupMarOptions.includes(item["STATUS"])){
          if(item["STATUS"])
          this.popupMarOptions.push(item["STATUS"]);
        }
        let typeText, mainStatus, className;
        if (this.configData.events && this.configData.events[0] &&
          this.configData.events[0].props[0]) {
          this.iconDetails = this.configData.events[0].props[0];
          if (this.iconDetails['iconText'] && this.iconDetails['iconText'].includes(item["status"])) {
            typeText = item["status"] ? item["status"].substring(0, this.iconDetails['iconTextChars']) : '';
            mainStatus = item["status"];
          } else {
            typeText = item["status"] ? item["status"].charAt(0) : '';
            mainStatus = item["status"];
          }
          if(this.iconDetails['statusSucessBorder'] && this.iconDetails['statusSucessBorder'].includes(item["status"])){
            className = 'dhl-ptype-' + typeText +'-green-bordered-v2'
          } else if(this.iconDetails['statusFailedBorder'] && this.iconDetails['statusFailedBorder'].includes(item["status"])){
            className = 'dhl-ptype-' + typeText +'-bordered-v2'
          } else if(item['locationId'] ){
            className = 'dhl-ptype-' + typeText +'-location-v2'
          } else{
            className = 'dhl-ptype-' + typeText +'-v2'
            //Cp-5592 - start
            if (item["status"] && item["status"].toLowerCase() == "delivered") {
              className = 'dhl-ptype-' + "Del" + '-v2';
            }
            //Cp-5592 - end
            //Cp-8790 - start Delivery Confirmed, Pending Acceptance, Planning Failed 
            if(item["status"] == "EnrichmentOnHold" || item["status"] == "VerificationOnHold" || item["status"] == "OnHold"){
              item["className"] = 'dhl-type-' + item["TypeText"] + '-DottedLine';
            }
            if (item["status"] && item["status"] == "DeliveryConfirmed") {
              className = 'dhl-ptype-' + "DelCon" + '-v3';
            }
            if (item["status"] && item["status"] == "PendingAcceptance") {
              item["className"] = 'dhl-ptype-' + "PA" + '-v3';
            }
            if (item["status"] && item["status"] == "PlanningFailed") {
              className = 'dhl-type-PF-bordered-v2';
            }
            if (item["status"] && item["status"] == "InTransit") {
              item["className"] = 'dhl-ptype-' + "IT" + '-v3';
            }
            if (item["status"] == "Dispatched") {
              item["className"] = 'dhl-type-DISP-bordered-v2';
            }
            //Cp-8790 - end
          }
        }
        if(this.configData["StatusIconsForGSK"]){
        if(item["status"]==='In Review'){
          typeText = 'IR';
          item["className"]= 'dhl-IR-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Reviewed'){
          typeText = 'R'
          item["className"]= 'dhl-R-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Sent To TMS'){
          typeText = 'STM'
          item["className"]= 'dhl-ST-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Cancelled'){
          typeText = 'C'
          item["className"]= 'dhl-C-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Sent For Verification'){
          typeText = 'SV'
          item["className"]= 'dhl-SV-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Verification Failed'){
          typeText = 'VF'
          item["className"]= 'dhl-VF-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Rejected In TMS'){
          typeText = 'RTM'
          item["className"]= 'dhl-RTM-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else if(item["status"]==='Sent To TMS Failed'){
          typeText = 'STF'
          item["className"]= 'dhl-STF-gsk dhl-data-upload-status';
          className = item["className"];
        }
        else{
          typeText = item["status"] ;
          item["className"]=  'dhl-'+item["status"]+'-gsk';
          className = item["className"];
        }
      }
         //Data Upload listing status start
         if (item.otm_Statusvalues) {
          if (item["status"] == "FAILED") {
            item["className"] = 'dhl-type-failed-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "F";
          }
          if (item["status"] == "SUCCESS") {
            item["className"] = 'dhl-type-success-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "S"
          }
          if (item["status"] == "IN PROGRESS") {
            item["className"] = 'dhl-type-IP-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "IP";
          }
          if (item["status"] == "CODE ERROR") {
            item["className"] = 'dhl-type-CE-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "CE";
          }
          if (item["status"] == "FRESH") {
            item["className"] = 'dhl-type-FR-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "FR";
          }
          if (item["status"] == "STAGED") {
            item["className"] = 'dhl-type-IP-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "SG";
          }
          if (item["status"] == "STARTED") {
            item["className"] = 'dhl-type-STR-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "ST";
          }
          if (item["status"] == "NOT-STARTED") {
            item["className"] = 'dhl-type-notstarted-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "NT";
          }
          if (item["status"] == "UNKNOWN") {
            item["className"] = 'dhl-type-unknown-v2 dhl-data-upload-status';
            className = item["className"];
            typeText = "UN";
          }
          //Data Upload listing end
        }
        if (this.popupOptions.find((option) => option.status === status) === undefined) {
          if(status){
            this.popupOptions.push({
              'status': status,
              'TypeText': typeText,
              'mainStatus': mainStatus,
              'className': className,
              'isLocationId': item['locationId']
            });
          }
        }
        if (this.tableconfig.rowOptions && this.tableconfig.rowOptions.events[0].eventConfig
          && this.tableconfig.rowOptions.events[0].eventConfig.matchcolumnValue
          && this.tableconfig.rowOptions.events[0].eventConfig.matchcolumnValue.indexOf(item.status) !== -1 && item.disabled) {
          if (item['verificationOngoing']) {
            item.title = 'Verification on going';
          } else if (item['escalatedTo']) {
            item.title = 'Escalated order';
          } else if(item['status'] === 'Enriched' && item['verificationDate']){
            item.title='Order has already been sent to TMS';
          }
           else {
            item.title = 'Order from a different pickup location';
          }
        } else {
          item.title = '';
        }
      });
      if (this.configData?.shipConfirm === true){
        this.tableRows.forEach(order => {
          if( order["STATUS"] === 'SHIP_CONFIRMED'){
            order.shipStatus = false;
          }else if(order["STATUS"] === 'SHIP_NOT_CONFIRMED'){
            order.shipStatus = true;
          }
        });
      }
    }

  }
  getMatchingStatus(orderSubStatus: any): boolean {
    let validSusStatuses = {
      "OriginAddressEnriched": false,
      "DestinationAddressEnriched": false,
      "ClientEnriched": false,
      "PayerEnriched": false,
      "orderauctioncodeEnriched": false,
      "vinisValid": false,
      "QuoteIDEnriched": false,
      "GatepassEnriched": false,
      "VehicleReleaseGenericEnriched": false,
      "VehicleReleaseEnriched": false,
      "GateReleaseEligibleEnriched": false,
      "contractedchecked": false,
      "pickupNamePhoneEnrichmentEnriched": false,
      "dropoffNamePhoneEnrichmentEnriched": false,
      "StagingLocationEnriched": false,
      "VehicleDetailsEnriched": false,
      "VYMMEnriched": false,
      "EnrichedInventoryTypeEnriched": false,
      "lessThan100miles": false,
      "clientActive": false,
      "payerActive": false

    };
    return Object.keys(orderSubStatus).some(key => {
      return validSusStatuses.hasOwnProperty(key) && orderSubStatus[key] === false;
    });
  }

  editFieldConfig(sCancel,tableHeaders)
  {
    this.tblHeaders=tableHeaders
    this.editField = true;
    this.apiService.makeHttpGetRequest(APP_Constants.LISTING_CONFIG_TEMPLATE +'&loggedInUser='+localStorage.getItem('userName')).subscribe(
      (res : any) => {
          this.isLoading = false;
          if (res.data.template !== null) {
            this.apiService.setOrderTemplate(tableHeaders);
            this.templateData =tableHeaders;
          }
        })
        err => {
          this.isLoading = false;

          let modal = new Modal({
            action: false, name: 'orderEntry', title: ModalConfigData.TITLES.ORDERENTRY, description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);
        };
    //take tempalte for edit form field componenet

    if(sCancel == 'cancel')
    {
      this.editField = false; 
    }
  }

  getFormStatus(e) {
    this.orderFormSubmitted = e;
  }

  
  getForm(e) {
    this.orderForm = e;
  }
  
  getUIStatus(rowData) {
    if (this.configData.checkSubstatus) {
      let orderSubStatus = rowData.orderSubStatus ? rowData.orderSubStatus : "";
      if (this.getMatchingStatus(orderSubStatus) || rowData.escalationFlag) {
        if (rowData.status === 'EnrichmentFailed' || rowData.escalationFlag) {
          return "Action";
        } else if (
          (rowData.status == "VerificationOnHold" || rowData.status == "EnrichmentOnHold" || rowData.status == "Enriched" || rowData.status == "VerificationInProgress" || rowData.isTrueOffsite)
          ) {
          return "Action";
        }
      } 
       if (
        (rowData.status == "VerificationOnHold" || rowData.status == "EnrichmentOnHold" || rowData.status == "Enriched" || rowData.status == "VerificationInProgress" || rowData.isTrueOffsite)
        && !rowData.escalationFlag
        && rowData.status != 'EnrichmentFailed'
      ) {
        return "Info";
      }
    }
    return null;
  }
   
  @ViewChild('dhlColumOrderPopupId', {static: true, read: ElementRef}) dhlColumOrderPopupId: ElementRef;
  @ViewChild('scroll', {static: true, read: ElementRef}) public scroll: ElementRef<any>;
  pageNo = 1;
  showLoadMore: boolean = false;
  showLoadMoreLabel: boolean = false;
  pageSize;
  sortKeyLoadMore;
  sortingModeLoadMore;
  pageNum = 0;
  color: String = 'warn';
  mode: String = 'indeterminate';
  isLoading: boolean = false;
  tableRows: any;
  //escalateRoles:string;
  tblHeaders: any;
  isSelRow:boolean=false;
  isSmallDevice : boolean;
  ShowColumnResizer : boolean;
  ShowHilighter : boolean = false;
  tHeaders:any;
  columnOrder:boolean = false;
  popupOptions : any=[];
  popupMarOptions:any=[];
  initialWidth;
  columnOptions:any = [];
  ColOptions:any;
  rearrangeColumns:any=[];
  columnNotResizableOptions:any=[];
  isDisplayStatus : boolean;
  isHover: boolean;
  Textkey:any=[];
  rowActions:any=[];
  isDisplayStatusM: boolean;
  isDisplayActions : boolean = false;
  businessObjectIdType: any;
  tableconfig: any;
  selectionArray: any = [];
  checkboxAllStatus: boolean = false;
  sortingMode:any = {} // Cache of the sortingMode to sort the table after an scroll
  sortingKey = []; // Cache of the sortingKey to sort the table after an scroll
  popmsgHead = '';
  dhlPopup;
  oldTableRows : any = [];
  dhlEventsDataObj : any = [];
  startIndex: number = 0;
  endIndex: number = 2;
  isTrusted;
  //dhlColumOrderPop_up = document.getElementById('dhlColumOrderPopup');
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
  .pipe(
    map(result => result.matches),
    shareReplay()
  );
  rowOptions : any;
  constructor(private modalService: ModalService, private apiService: AppService, private router: Router, private breakpointObserver:BreakpointObserver,public translate: TranslateService,
    private changeDetector: ChangeDetectorRef, private domEventService: DomEventService, private coxService :CoxService,
    private datePipe: DatePipe, private clipboard: Clipboard, private _snackBar: CustomSnackBarService, private alphaService:AlphaService) { }

  dummyCustomer;
  tableRowsClone: any;
  scrollPagination = 1;
  scrollTotalPages = 1;
  stopScroll = false;
  isMassPORelease = false;

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    if(this.configData.validation)
    if(this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
    this.dummyCustomer = localStorage.getItem('customerCode');
    this.pageSize = this.configData.searchResults[0].maxRows;
    this.rowActions = this.configData.searchResults? this.configData.searchResults[0].rowActions: [];
    this.businessObjectIdType = this.configData.searchResults? this.configData.searchResults[0].businessObjectId: 'businessObjectId';
    if(window.innerWidth >= 701 && window.innerWidth <= 1023)
  	{
	  	this.highlightColumnTabletView();
	  }
    if(this.configData.events && this.configData.events[0] && this.configData.events[0].props[0])
    {
      this.iconDetails = this.configData.events[0].props[0];
    }
    if(this.tableData && this.tableData.length > 0){
    this.tableRows = this.tableData
    } else{
      this.getData(null);
    }
    this.ShowColumnResizer = false;
     if(this.configData.resizing !== undefined && this.configData.resizing !==null){
        this.ShowColumnResizer = this.configData.resizing;
    }
     // remove this code after testing
    // for (let action of this.rowActions)
    // if(action.name=="escalate")
    // this.escalateRoles=action.roleAccess
    // console.log("roles"+this.escalateRoles)
    if(this.isHandset$)
    {
      this.isSmallDevice = false;
    }
    else
    {
      this.isSmallDevice = true;
    }
    this.resetColumnOrder();
    //this.ColOptions = this.columnOrderOptions();
    this.clickEventSubscription = this.domEventService.click.subscribe((e: MouseEvent) => this.onWindowClick(e));

    //persona implimentation
    if(this.configData.searchResults && this.configData.searchResults[0].rowActions){
      this.configData.searchResults[0].rowActions.forEach(ele => {
        if (ele['dynamicVisibility']) {
          if(ele['dynamicVisibility'].action == 'hidden'){
            ele['hidden'] = !this.checkUserAccess(ele['dynamicVisibility'].featureName);
          }else if(ele['dynamicVisibility'].action == 'disabled'){
            if(this.checkUserAccess(ele['dynamicVisibility'].featureName) == false){
              ele['disabled'] = true;
            }
          }
        }
        if (ele['editAccess']) {
          ele['editAccess'].forEach(row => {
            if(row.action.includes('disabled') || row.action.includes('hidden')){
              let persona;
              if(row.roleAccess){
                persona = row.roleAccess;
              } else {
                persona = row.persona;
              }
              if(this.checkFieldAccess(persona) === true && row.action.includes('hidden'))
                {
                  ele['hidden'] = true;
                }
              else if(this.checkFieldAccess(persona) === true)
                {
                  ele['disabled'] = true;
                }
            }
          });
        }
      });
    }
    this.endIndex = this.configData.displayColumn ? this.configData.displayColumn : 2; //CP-4798 No of column to display in table header
    localStorage.removeItem('TotalPoLinesSelected');
    localStorage.removeItem('ResetPoSelected')

    if(this.configData?.showPreview) {
      this.valueChangesSub = this.frmGroup.get(this.configData.name).valueChanges.subscribe((value) => {
        this.tableRows = value;
        this.changeDetector.markForCheck();
      });
    }
    if(parseInt(localStorage.getItem('TotalPoLinesSelected')) == 0 || localStorage.getItem('TotalPoLinesSelected') == 'NaN')
    {
      this.rowDataSelect = undefined;
      this.checkboxAllStatus = false;
    }
  }

  //Row select and update data
  toggleSearchPreference(e, row, rowOptions){
    e.preventDefault();
    e.stopPropagation();
    this.selection.toggle(row);
    row.favourite = this.selection.isSelected(row);
    let event: DhlFormControlEvent | null = this.checkEventExist(rowOptions.events, 'ROW_SELECT');
    if (event) {
      this.sendToSource(event, row);
    }
  }
  isRowSelected(row) {
    let selected = this.selection.isSelected(row) ||  row.favourite ;
    if(selected){
      this.selection.select(row);
      return this.selection.isSelected(row);
    }
    return false;
  }
  //End

  onWindowClick(event) {
    let dhlPopup = document.getElementById('dhlPopupId');
    let bodyClick = document.getElementsByTagName('body')[0];
    if (dhlPopup && bodyClick != event.target &&  !dhlPopup.contains(event.target)) {
      this.displayColumnOrder(event,'cancel');
    }
    // to close the more action popup
    if(document.getElementById('moreAction') && !document.getElementById('moreAction').contains(event.target)){
      this.isDisplayActions = false;
    }
  }

  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }

  setcolumnOrderOptions(sCancel='')
  {
    this.columnOptions = JSON.parse(localStorage.getItem('ColumnOrderOptions'));
    this.columnOptions.forEach(item => {
      if((item["title"]!= '' || item["key"] == 'select') && item["key"]!= 'Settings')
      {
        this.tHeaders.forEach(element => {
          if(item['title'] == element['title'])
          {
            if(element.primaryText.key != 'Settings')
            {
              console.log("element",element);
              this.rearrangeColumns.push(element);
            }
          }
        });
      }
    });
    this.tHeaders.forEach(element => {
      var primaryText = element['primaryText'];
      // CP-4798 It will not push that column which is already exist in manage column modal
      let mobileManageColumnOrder = element["mobileManageColumnOrder"] === false ? element["mobileManageColumnOrder"] : true;
      if((primaryText["key"] == 'Actions' && mobileManageColumnOrder) || primaryText["key"] == 'Settings')
      {
        this.rearrangeColumns.push(element);
      }
    });
    this.tHeaders = this.rearrangeColumns;
    this.rearrangeColumns = [];
    if(sCancel == 'cancel')
    {
      this.columnOrder = false;
    }
  }

  setCheckAll(dhlEvents, $event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    const hasMatchingRecords = this.tableRows?.some(({ disabled }) => disabled === false);
    const selectedPoLines = JSON.parse(localStorage.getItem("selectedPoLines"));
    if (Array.isArray(selectedPoLines) && selectedPoLines?.length > 0 && !hasMatchingRecords) {
      this.checkboxAllStatus = false;
      return;
    }

    const findSelectedDataInRows = this.tableRows?.find(({ ORDER_BASE_LINE_XID }) => {
      return ORDER_BASE_LINE_XID === this.rowDataSelect?.ORDER_BASE_LINE_XID;
    });
    if(parseInt(localStorage.getItem('TotalPoLinesSelected')) == 0 || localStorage.getItem('TotalPoLinesSelected') == 'NaN' || localStorage.getItem('TotalPoLinesSelected') == 'null')
    {
      this.rowDataSelect = undefined;
    }
    else
    {
      this.checkboxAllStatus = !this.checkboxAllStatus;
    }
    if (this.checkboxAllStatus) {
      this.alphaService.updatePoSelectAllList(this.selectionArray, this.selectionArrayForSelectAll, 'ORDER_BASE_LINE_XID');
      this.tableRows.forEach(item => {
        if(item.disabled === true) {
          item.selected = false;
        } else {
          item.selected = true;
          //this.selectionArrayForSelectAll.push(item);
          this.alphaService.addItemIfNotPresent(this.selectionArrayForSelectAll, item, 'ORDER_BASE_LINE_XID');
          this.alphaService.addItemIfNotPresent(this.selectionArray, item, 'ORDER_BASE_LINE_XID');
        }
        if (this.isMassPORelease) {
          this.selectionArrayForSelectAll = [];
          this.tableRowsClone.forEach((item) => {
            /* Removed this because it was adding duplicates and overriding selection state:
            item.selected = true;
            this.selectionArrayForSelectAll.push(item);*/
             if (item.disabled === true) {
              item.selected = false;
            } else {
              item.selected = true;
              this.alphaService.addItemIfNotPresent(this.selectionArrayForSelectAll, item, 'ORDER_BASE_LINE_XID');
              this.alphaService.addItemIfNotPresent(this.selectionArray, item, 'ORDER_BASE_LINE_XID');
            } 
          });
        }
      });
      this.alphaService.updatePoSelectAllList(this.selectionArray, this.selectionArrayForSelectAll, 'ORDER_BASE_LINE_XID');
    } else {
      this.selectionArrayForSelectAll = [];
      this.selectionArray = [];
      this.dhlEventsDataObj = [];
      this.tableRows.forEach(item => {
        item.selected = false;
        item.disabled = false;
        this.changeDetector.detectChanges();
      });
      if (this.isMassPORelease) {
        this.tableRowsClone.forEach((item) => {
          item.selected = false;
          item.disabled = false;
        });
      }
      localStorage.setItem('TotalPoLinesSelected', "0");
      localStorage.setItem('ResetPoSelected', "0");
      localStorage.setItem('selectedPoLines', JSON.stringify([]));
      document.getElementById('poSelectCount').innerHTML = '0';
      this.rowDataSelect = undefined; 
    }
    if(this.rowDataSelect)
    {
      this.setSelectedBoxStatus(this.rowDataSelect, dhlEvents, $event);
    }
    if (!findSelectedDataInRows) this.rowDataSelect = undefined;
  }

  selectedOption(row, evt, dhlEvents, autoSelect = false) {
    if(!this.checkboxAllStatus)
    this.selectionArrayForSelectAll=[];
    evt ? evt.preventDefault(): null;
    evt ? evt.stopPropagation(): null;
    if(row.disabled || row.locked){
      return
    }
    // this.tableconfig.rowOptions.isSelectAll = false;
    row.selected = !row.selected;
    setTimeout(()=>{
      if (row.selected && !autoSelect) {
       // this.tableconfig.rowOptions.isSelectAll = true;
        //this.selectionArray?.push(row);
        this.alphaService.addItemIfNotPresent(this.selectionArray, row, 'ORDER_BASE_LINE_XID');
        //Set object for globle use, Push
        this.dhlEventsDataObj.push({
          row : row,
          dhlEvents : dhlEvents
        })
      }
      if (!row.selected) {
        this.checkboxAllStatus=false
        if(this.selectionArrayForSelectAll.length > 0){
          this.selectionArray = this.selectionArrayForSelectAll.filter((obj) => {
            return row.ORDER_BASE_LINE_XID !== obj.ORDER_BASE_LINE_XID;
        });
      }else{
        this.selectionArray = this.selectionArray.filter(function (obj) {
          return row.ORDER_BASE_LINE_XID !== obj.ORDER_BASE_LINE_XID;
        });
      }
        //remove object for globle use,
        this.dhlEventsDataObj = this.dhlEventsDataObj.filter(function (obj) {
          return obj.row.selected;
        })
      }
      this.setSelectedBoxStatus(row, dhlEvents, evt);
    },200)
  }


  setSelectedBoxStatus = (row, dhlEvents, e:any) => {
    e ? e.preventDefault() : '';
    e ? e.stopImmediatePropagation() : '';
    this.rowDataSelect=row;
    let event: DhlFormControlEvent | null = this.checkEventExist(dhlEvents, 'MULTI_ROW_SELECT');
    let singleRowEvent: DhlFormControlEvent | null = this.checkEventExist(dhlEvents, 'SINGLE_ROW_SELECT');
    this.singleRowEvent = singleRowEvent;
    this.multiRowEvent = event;
    let currrentEvent = event || singleRowEvent;
    const findSelectedDataInRows = this.tableRows?.find(({ ORDER_BASE_LINE_XID }) => {
      return ORDER_BASE_LINE_XID === this.rowDataSelect?.ORDER_BASE_LINE_XID;
    });
    if (currrentEvent) {
      if (currrentEvent.eventConfig['allowOnlySameRecord'] && findSelectedDataInRows && (row?.selected || this.selectionArray.length == 0)) {
        localStorage.setItem('TotalPoLinesSelected',this.selectionArray.length)
        localStorage.setItem('ResetPoSelected',this.selectionArray.length)
        if (findSelectedDataInRows) this.disableRows(currrentEvent.eventConfig, row);
      } else if(this.selectionArray.length > 0 && this.selectionArrayForSelectAll.length > 0 && !findSelectedDataInRows) {
        localStorage.setItem('TotalPoLinesSelected', this.selectionArray.length);
        localStorage.setItem('ResetPoSelected', this.selectionArray.length);
        if(!row?.selected) row.selected = true;
        this.disableRows(currrentEvent.eventConfig, row);
      }else if(currrentEvent?.eventConfig['matchOverlapDate'] && this.selectionArray?.length > 0){
        this.disableRows(currrentEvent?.eventConfig, row);
      }
      if (dhlEvents[0]?.eventConfig?.matchAnyOneSimilarity && currrentEvent.eventConfig['allowOnlySameRecord'] && !row?.selected) {
        this.selectionArray = this.selectionArray.filter(selectedRow => selectedRow.ORDER_BASE_LINE_XID !== row.ORDER_BASE_LINE_XID);
        this.disableRows(currrentEvent.eventConfig, row);
      }
      let data;
      if(this.checkboxAllStatus){
        data = this.selectionArrayForSelectAll.filter((obj) => {
          return obj.selected;
        });
        
        if(data?.length == 0) data = this.selectionArray;
     }else{
      data = singleRowEvent ? row : this.selectionArray;
      }
            this.sendToSource(currrentEvent, data);
    }
  }

  disableRows(event, data){
    this.tableRows.map(row => {
      row.disabled = false;
      // matchStrategy defines the matching logic:
      // 'shouldMatchAny' means at least one condition must match (OR logic)
      // 'shouldMatchAll' means all conditions must match (AND logic)
    let matchStrategy = event?.matchAnyOneSimilarity ? 'shouldMatchAny' : 'shouldMatchAll';
    if (matchStrategy == 'shouldMatchAll' && event['matchingKey']) {
      for (let key of event['matchingKey']) {
        if ((row[key] != data[key]) && data.selected) {
          row.disabled = true;
          row.selected=false;
          break;
        }
      };
    }   
    
    if(event && event['matchOverlapDate'] && matchStrategy == 'shouldMatchAll' && event['matchingKey']){
      let searchTemplate = this.apiService.getOrderTemplate()
      this.alphaService.enablePOWithOverlapDatedOnly(searchTemplate,this.selectionArray,row);
    }

    
    if (matchStrategy == 'shouldMatchAny') {
      // 13312 Order selection for verification - enhancement
      const matchingKeys = event.inventoryType?.toLowerCase() === data['inventoryType']?.toLowerCase() ? event.matchingKeyRepo : event.matchingKeyNonRepo;

      let isMatching = false;
      for(let matchKey of matchingKeys){
        if (data.selected && row[matchKey] && data[matchKey] && String(row[matchKey]).trim() !== '' && String(data[matchKey]).trim() !== '' && String(row[matchKey]).trim() === String(data[matchKey]).trim()) {
          isMatching = true;
          break;
        }
      }

      if(!isMatching && data.selected ){
        row.disabled = true;
        row.selected = false;
      }
      }

      event?.roleBasedPOValidations?.forEach(obj => {  
        for (let role of obj.userRole) {
          if (role === localStorage.getItem('userRole')) {
            let fieldName = obj?.checkField?.name || "",
              fieldValue = obj?.checkField?.value || "",
              additionalKey = obj?.checkField?.matchingKey || "";
            for (let key of obj['matchingKey']) {
              if ((row[key] !== data[key]) && data?.selected) {
                row.disabled = true;
                row.selected = false;
                break;
              } else if (key === fieldName && data[fieldName] === fieldValue && row[fieldName] === fieldValue && row[additionalKey] !== data[additionalKey] && data?.selected) {
                row.disabled = true;
                row.selected = false;
                break;
              }
            };
          }
        }
      });
    let result;
    if(event['matchcolumnValue']){
      result = event['matchcolumnValue'].indexOf(row[event['matchcolumnName']]);
    }
    if(result !== -1 && row['escalatedTo']){
      result = event['matchcolumnValue'].indexOf(row['escalatedTo'].toLowerCase());
    }
    if(result !== -1 && row['verificationOngoing']){
      result = -1;
    }
    if(row['verificationDate']){
      result= -1;
    }
	  if(result == -1){
		  row.disabled = true;
	  }
    });
    if (this.isMassPORelease) {
      this.tableRowsClone.map((row) => {
        row.disabled = false;
        for (let key of event['matchingKey']) {
          if (row[key] != data[key] && data.selected) {
            row.disabled = true;
            row.selected = false;
            break;
          }
        }
      });
    }
  }

  checkdisableRow(CheckSelection,orderStatus,matchColumnName){
    let result;
    if(matchColumnName){
      result = matchColumnName.indexOf(orderStatus);
    }
    if (this.configData?.checkStatusOut) {
      this.tableRows.map(row => {
        if (this.configData?.checkStatusOut[0].indexOf(row["OB_STATUS_TYPE"]) > -1) {
          row.disabled = true;
          row.selected = false;
          return
        }
      })
    }
	  if(CheckSelection && result == -1)
	  {
		  return true;
	  }
	  else
	  {
		  return false;
	  }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }
 /** Row click can be handled here */
 onRowClickHandler(row, rowOptions, $event) {
  $event.preventDefault();
  $event.stopImmediatePropagation();
    let event: DhlFormControlEvent | null = this.checkEventExist(rowOptions.events, 'ROW_CLICK');
    if (event) {
      this.sendToSource(event, row);
    }
  }

  sendToSource(event: DhlFormControlEvent, row = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.apiService._commonComponentSubject.next(eventData);
  }

  resetColumnOrder()
  {
    this.columnOptions = [];
    localStorage.setItem('ColumnOrderOptions', JSON.stringify(this.columnOptions));
    this.tableconfig = this.configData.searchResults[0];
    this.tHeaders = this.configData.searchResults[0].TableHeaders;
    //store object defualt order in local storage
    this.tHeaders.forEach(item => {
      if(item["reorder"])
      {
        let primaryText = item["primaryText"];
        this.columnOptions.push({title:item["title"],draggable:item['draggable'],key:primaryText["key"]});
      }
    });
    localStorage.setItem('ColumnOrderOptions', JSON.stringify(this.columnOptions));
    this.columnOrder = false;
  }
  columnOrderOptions(){
    return localStorage.getItem('ColumnOrderOptions');
  }

  drop(event: CdkDragDrop<string[]>) {
    //find the draggable is allowd or not
    var currentDropIndex = event.currentIndex;
    if(!this.columnOptions[currentDropIndex].draggable){
    return // this will stop item from drop
    }
    moveItemInArray(this.columnOptions, event.previousIndex, event.currentIndex);
    localStorage.setItem('ColumnOrderOptions', JSON.stringify(this.columnOptions));
  }


  ngAfterViewInit(){
    // below function is called to retain the sort Functionality every time user revisits the orderlisting page
    this.retrieveSortingState()
    this.initialWidth = (<HTMLElement>(document.getElementsByClassName('table').item(0))).offsetWidth;
    if (this.ShowColumnResizer)
         this.resizing();
    
    this.commonSubject = this.apiService._commonComponentSubject.subscribe(res => {
      if(res && res.totalRecordsCount){
        this.totalRecordsCount = res.totalRecordsCount;
      }
      if (res.action === 'DATA_GET_SELECT') {
        let selectedPoLines = JSON.parse(localStorage.getItem("selectedPoLines")) || [];
        if (selectedPoLines?.length > 0) {
          this.tableRows.forEach(item => {
            let isSelectView = selectedPoLines.filter((val) => val.ORDER_BASE_LINE_XID == item.ORDER_BASE_LINE_XID && !item.selected);
            if (isSelectView.length > 0) {
              this.selectedOption(item, null, this.tableconfig.rowOptions.events, false);
            } else {
              let currrentEvent = this.multiRowEvent || this.singleRowEvent;
              if (selectedPoLines?.length > 0 && currrentEvent) {
                if(!selectedPoLines?.[0]?.selected) selectedPoLines[0].selected = true;
                this.disableRows(currrentEvent.eventConfig, selectedPoLines[0]);
              }
            }
          })
        }
      }
      if(res.action === 'SET_STATUS_DATA') {
        this.setStatusDetails();      
      }
      if(this.configData?.searchResults[0]?.isMassPORelease && localStorage.getItem('massiveSearch'))
      {
        this.handleMassive();
      }

      if(res.action === 'LOAD_MORE') {
        if(this.checkboxAllStatus) {
          this.checkboxAllStatus = false;
        }
      }
    })

    this.isHandset$.subscribe((res: boolean) => {
      this.isSmallDevice = res; 
    })
   }

  getData(userEvent){
    if(this.configData && this.configData.events && this.configData.events.length > 0){
      let events = this.configData.events;
      let eventData: DhlFormControlEventData = {
        event: events[0].event,
        eventData: events[0],
        action: events[0].action,
        name: this.configData.name,
        component: this,
        configData: this.configData,
        data: this.pageNo,
        docPreview: this.frmGroup.get(this.configData.name)?.value ?? null
      };
      eventData['userEvent'] = userEvent;
      this.apiService._commonComponentSubject.next(eventData);
    }
  }
  displayOrderDetails(index,ordDtl) {
    this.tableRows.forEach(function(ord, idx){
      ord["isSelRow"] = idx == index ? !ord["isSelRow"] : false;
    });
  }

  handleColumnActions(event, data , thl) {
    event.preventDefault();
    event.stopPropagation();
    if (thl.columnClickable) {
      let eventData: any;
      if(thl.events && thl.events.length > 0){
        eventData = {
          action: thl.events[0].actionType,
          eventConfig: null,
          event: thl.events[0],
          configData: thl.modal ? thl.modal[0].actions : this.configData
        };
      }else{
        eventData = {
          action: thl.events.actionType,
          eventConfig: null,
          event: thl.events,
          configData: thl.modal ? thl.modal[0].actions : this.configData
        };
      }
     this.sendToSource(eventData, data);
    }
  }

  handleRowActions(event,action, businessObjectId, rowData){
    this.isDisplayActions = false;
    event.stopImmediatePropagation();
    let events = this.checkEventExist(action.events, 'CLICK');
    if (events) {
      return this.sendToSource(events, { rowData: rowData, rowAction: action });
    } else if (action === 'ROW_CLICK' || action.name === "draftView") {
      localStorage.setItem('templatedata', JSON.stringify(rowData));
      let eventData: DhlFormControlEvent = {
        action: action,
        eventConfig: null,
        event: "ROW_CLICK"
      }
      if (this.configData.isSelectAll){
      let isSelectAllCount = rowData.poLines.length;
      let TotalPoLinesSelected = localStorage.getItem('TotalPoLinesSelected');
      if(isSelectAllCount !== TotalPoLinesSelected){
        localStorage.setItem('TotalPoLinesSelected',isSelectAllCount)
        localStorage.setItem('ResetPoSelected',isSelectAllCount)
      }
    }
      if (rowData?.LATE_DELIVERY_DATE) {
        localStorage.setItem('poDeliveryDate', rowData.LATE_DELIVERY_DATE);
      }
    this.sendToSource(eventData, rowData);
    } else if (action.name === 'approve' || action.name === "decline") {
      let eventData: DhlFormControlEvent = {
        action: action.name,
        eventConfig: null,
        event: "APPROVE_DECLINE"
      }
      this.sendToSource(eventData, rowData);
    }

    if(action.name === "edit"){
      if(localStorage.getItem('filterCurrenturl') == "/shipments")
      {
        let stop_number = rowData.STOP_NUMBER;
        businessObjectId += "/"+stop_number;
      }
      localStorage.setItem('templatedata', JSON.stringify(rowData))
      //this.configData.searchResults[0].businessObjectId
      this.editOrder(action,businessObjectId) ;
    } else if(action.name === "cancel" && rowData.status != 'Cancelled'){
      this.cancelOrder(action, businessObjectId,rowData);
    } else if(action.name === "download"){
      this.fileDownload(action, businessObjectId);
    }else if(action.name === "copy"){
      this.copyOrder(action, businessObjectId, rowData);
    }

    // check type of action and execute accordingly
    if(action.type === 'MODAL'){
      // fetch modal info from modalContent and set to modal config
      let modalConfig = {
        action: true, name: action.modalConfig.name, title: action.modalConfig.title,
        description: action.modalConfig.description,
        version: 'v2',  type: action.modalConfig.type,
        style: { width: "50vw", maxHeight: "50vh" }, config: action.modalConfig, data: (rowData['documents'])
      };
      let modal = new Modal(modalConfig);
      this.modalService.createModalBox(modal, 200);
    }
     // remove this code after testing
   //else if(action.name === "vip"){
  //     this.setVIPFlag(action, businessObjectId, rowData);
  //     event.stopImmediatePropagation();
  //   } else if(action.name === "escalate"){
  //     if(this.isAccessible(this.escalateRoles)==true || (rowData["escalationFlag"]==false && rowData["status"]!="SentToTMS")){
  //     this.setEscalationFlag(action, businessObjectId, rowData);
  //   }
  //   event.stopImmediatePropagation();
  // }
}

  handleRowCheck(event, action, businessObjectId, rowData) {
    if (event.target.checked) {
      this.checkedIds.push(businessObjectId);
      this.checkedItems.push(rowData);
    }
    else {
      const index = this.checkedIds.indexOf(businessObjectId, 0)
      const itemIndex = this.checkedItems.findIndex(item => item[this.businessObjectIdType] === businessObjectId);
      if (index > -1)
        this.checkedIds.splice(index, 1)
      if (itemIndex > -1) {
        this.checkedItems.splice(itemIndex, 1);
      }
    }
    let events = this.checkEventExist(action.events, 'CHECK');
    if (events) {
      let data = {
        checkedIds: this.checkedIds, checkedOrders: this.checkedItems, rowAction: action,
        checked: event.target.checked, businessObjectId: businessObjectId
      }
      this.sendToSource(events, data)
       // remove this code after testing
      //   let eventData: DhlFormControlEventData = {
      //     event: events[0].event,
      //     eventData: events[0],
      //     action: 'VERIFY',
      //     name: this.configData.name,
      //     component: this,
      //     configData: this.configData,
      //     data: {
      //       checkedIds: this.checkedIds, checkedOrders: this.checkedItems, rowAction: action,
      //       checked: event.target.checked, businessObjectId: businessObjectId
      //     }
      //   }
      //   this.apiService._commonComponentSubject.next(eventData);
    }
  }
  // remove this code after testing
  // setVIPFlag(action, businessObjectId, ordData){
  //   let events = action.events;
  //  // if(events && events.length > 0) {
  //   let eventData: any = {
  //     // event: events[0].event,
  //     // eventData: events[0],
  //     action: action && action.name? action.name.toUpperCase(): '',
  //     name: this.configData.name,
  //     component: this,
  //     configData: this.configData,
  //     data: {businessObjectId: businessObjectId,orderExpedite: ordData.orderExpedite, rowAction: action}
  //   }
  //   this.apiService._commonComponentSubject.next(eventData);
  // // }
  // }
  // setEscalationFlag(action, businessObjectId, ordData){
  //   let events = action.events;
  //     let eventData: any = {
  //       action: action && action.name? action.name.toUpperCase(): '',
  //       name: this.configData.name,
  //       component: this,
  //       configData: this.configData,
  //       data: {businessObjectId: businessObjectId, shipper: ordData["shipper"], rowAction: action, escalationFlag: !ordData["escalationFlag"]}
  //     }
  //     this.apiService._commonComponentSubject.next(eventData);
  // }

  fileDownload(action,businessObjectId) {
      let events = action.events;
      if(events && events.length > 0) {
      let eventData: DhlFormControlEventData = {
        event: events[0].event,
        eventData: events[0],
        action: 'DOWNLOAD',
        name: this.configData.name,
        component: this,
        configData: this.configData,
       data: {orderId: businessObjectId, rowAction: action}
      }
      this.apiService._commonComponentSubject.next(eventData);
    }
  }


  copyOrder(action,businessObjectId,copyData){
    localStorage.setItem('isCopyOrder', 'true');
    let events = action.events;
    if(events && events.length > 0) {
    let eventData: DhlFormControlEventData = {
      event: events[0].event,
      eventData: events[0],
      action: 'COPY',
      name: this.configData.name,
      component: this,
      configData: this.configData,
     data: {orderId: businessObjectId, rowAction: action, copyData:copyData}
    }
    this.apiService._commonComponentSubject.next(eventData);
  }
  }

  isResend(ordData, action) {
    if(action['statusToBeResend']){
      let orderResend = action.statusToBeResend.includes(ordData.status)
      if(action.name === 'resend' && orderResend){
        action['toolTip'] = "Resend";
        action['hidden'] = false;
      } else if (action.name === 'resend' && !orderResend){
        action['toolTip']  = "";
        action['hidden'] = true;
      }
      return action.name === 'resend' && orderResend
    }
  }
  isVip(ordData, action) {
    return action.name === 'vip' && ordData.orderExpedite == false;
  }

  isNotVip(ordData, action) {
    return action.name === 'vip' && ordData.orderExpedite == true;
  }

  isDisable(action, ordData) {
    return ordData.status == 'Duplicate' && action.name !== 'edit' && action.name !== 'hold' ;
  }


  
  accessActionsByStatus(action, ordData) {
    const config = this.configData?.accessActionsByStatus;

    if (!config) return false;

    const isMatchingStatus = config.statusArray.includes(ordData?.STATUS);
    if (isMatchingStatus) ordData.disabled = true;

    return isMatchingStatus && config.actions.includes(action.name);
  }


  isCancelled(status, action) {
    return status == 'Cancelled' && action.name === 'cancel';
  }

  isEscalated(action, ordData) {
    return action.name === 'escalate' && ordData.escalationFlag == true;
  }

  isNotEscalated(action, ordData) {
    return action.name === 'escalate' && ordData.escalationFlag == false;
  }
  isEscalationNotesHistory(action, ordData) {
    if (ordData?.escalationHistory && action.name == 'escalationNotesHistory') {
      return action.name === 'escalationNotesHistory';
    }
  }
  holdDetails(action, ordData){
    return action.name === 'hold'
  }
  shouldDisplayAction(action,rowData) {
    return (action.name === 'escalationNotesHistory' && rowData.escalationHistory) || action.name !== 'escalationNotesHistory';
  }
  isOrderNotes(action, ordData) {
    return action.name === 'orderNotes';
  }

  checkAccess(action) {
    if (action.access) {
      return !(this.checkUserAccess(action.access))
    }
    return false
  }

  editOrder(action, businessObjectId) {
    if ((action.name && action.name === "edit") || !action.name) {
      // remove this code after testing
      // if (action.events && action.events.length > 0) {
      //   let eventData = {
      //     action: action.name.toUpperCase(),
      //     name: this.configData.name,
      //     component: this,
      //     configData: this.configData,
      //     data: { businessObjectId: businessObjectId, rowAction: action.name, escalateRoles: this.escalateRoles }
      //   }
      //   this.apiService._commonComponentSubject.next(eventData);
      // } else
      //  {
        let redirectUrl;
        if (this.configData.searchResults[0].rowClickUrl == undefined) {
          return
        }
        redirectUrl = this.configData.searchResults[0].rowClickUrl + businessObjectId;

        // if (this.escalateRoles)
        //   this.router.navigateByUrl(redirectUrl, { state: { roleAccess: this.escalateRoles } });
        // else {
          this.router.navigateByUrl(redirectUrl);
       // }
     // }
    }
  }

  cancelOrder(action, businessObjectId,ordData) {
      let events = action.events;
      if(events && events.length > 0) {
      let eventData: DhlFormControlEventData = {
        event: events[0].event,
        eventData: events[0],
        action: 'CANCEL',
        name: this.configData.name,
        component: this,
        configData: this.configData,
        data: {businessObjectId: businessObjectId, rowAction: action,ordData:ordData}
      }
      this.apiService._commonComponentSubject.next(eventData);
    }
  }

  selectedDivId(selectedId){
    console.log(selectedId);

  }

  displayColumnOrder($event,sCancel='')
  {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    this.columnOrder = true;

    if(sCancel == 'cancel')
    {

      this.columnOrder = false;

    }
  }
  resizing()
  {
    let rv=this.configData.resizeColumn;
    let resizable = new Array<boolean>();
    for (let i =0; i < this.configData.searchResults[0].TableHeaders.length;i++){
      resizable[i] = this.configData.searchResults[0].TableHeaders[i].resizable;
    }

    if(this.ShowColumnResizer)
    {
      var myTable;
      var myTableTag=document.getElementsByClassName('dhl-table-highlight-v2');
      var myTableTag2 = document.getElementsByClassName('dhl-table-layout-fixed-v2');
      var myTable2;
      var initWidth = this.initialWidth;
      var changeWidth =this.initialWidth;
    var thElm;
    var startOffset;
    var thOffsetArr=new Array();

    var maxWidth  ;
    var minWidth;
    var count=0;
    Array.prototype.forEach.call(
      document.querySelectorAll("table th.dhl-table-align-hover-v2"),
      function (th) {

        maxWidth = th.offsetWidth+Number(rv);
        minWidth = th.offsetWidth-Number(rv);
        th.maxWidth = maxWidth;
        th.minWidth = minWidth;
        th.resizable = resizable[count];
        count++;
        var grip = document.createElement('div');
        grip.innerHTML = "&nbsp;";
        grip.style.top = "0";
        grip.style.right = "-13px";
        grip.style.bottom = "0";
        grip.style.width = '34px';
        grip.style.height = '46px';
        grip.style.position = 'absolute';

        if(th.resizable){
          grip.className ="grip-class";
          grip.style.cursor = "url('./../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,0,24,24))'), auto";
        }
        else{
          grip.style.display = "none";
        }


        grip.addEventListener('mousedown', function (e) {


            startOffset = th.offsetWidth - e.pageX;
            for(var i=0;i<myTableTag.length;i++){
              var mySettingsTag = document.getElementsByClassName('dhl-settings-v2');
            var mySettings;
               myTable=myTableTag[i] as HTMLElement;
              myTable.classList.add('show');
              myTable2 = myTableTag2[0] as HTMLElement;
              myTable2.classList.add('fixed');

              mySettings = mySettingsTag[0] as HTMLElement;
              mySettings.classList.add('highlight');
            }


        });

        th.addEventListener('mousemove', function(e){
          th.style.border = "solid 1px transparent";
      });
        th.appendChild(grip);
        thOffsetArr.push(th.offsetWidth);
        });

    document.addEventListener('mousemove', function (e) {

      if (thElm) {
        thElm.style.border ="solid 2px #cccccc";
        thElm.style.borderRadius = "4px";


        thElm.style.width = startOffset + e.pageX + 'px';
        if(thElm.offsetWidth<=thElm.minWidth){
          thElm.style.width = thElm.minWidth + 'px';
        }

         if(thElm.offsetWidth>=thElm.maxWidth){
             thElm.style.width = thElm.maxWidth + 'px';
        }
      }
    });
    document.addEventListener('mouseout', function(e){
      if(thElm)
      thElm.style.border = "solid 1px transparent";


  });

    document.addEventListener('mouseup', function () {
      if(thElm)
      thElm.style.border = "solid 1px transparent";
      for(var i=0;i<myTableTag.length;i++){
        myTable=myTableTag[i] as HTMLElement;
        myTable2=myTableTag2[0] as HTMLElement;
        changeWidth = (<HTMLElement>(document.getElementsByClassName('table').item(0))).offsetWidth;
        if(changeWidth - initWidth <= 50){
          myTable.classList.remove('show');
          myTable2.classList.remove('fixed');
        }
        else{
          myTable.classList.add('show');
          myTable2.classList.add('fixed');
        }
      }
        thElm = undefined;
    });
 }
} 
// remove this code after testing
// isAccessible(roleAccess: string){
//   let menuPages = localStorage.getItem('userRole');
//   return menuPages.includes(roleAccess) ;
// }
checkUserAccess(roleAccess: string){
  let menuPages = localStorage.getItem('menuPages');
  return menuPages.includes(roleAccess) ;
}

  onScroll(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    //CP-4361-start
    if(this.scrollTopValue != event.target.scrollTop){
      this.scrollTopValue = event.target.scrollTop;
    //CP-4361-end
    // visible height + pixel scrolled >= total height
    if(this.tableRows.length > 49 && (this.tableRows.length < this.totalRecordsCount) && !this.similarSelected){ // no need to call API if similar button is selected
      if(this.configData.searchResults[0].incrementalLoadWhenScrolling && this.pageNo <= this.configData.searchResults[0].scrollLimit){
        if (event.target.offsetHeight + 2 + event.target.scrollTop >= event.target.scrollHeight) {
          this.pageNo = this.pageNo + 1;
          this.getData(event);
        }
      }
    };
    if (this.oldTableRows.length > 0 && (this.oldTableRows.length < this.tableRows.length)) {
      this.dhlEventsDataObj.forEach(element => {
        this.setSelectedBoxStatus(element.row, element.dhlEvents, event);
      });
    }
    this.oldTableRows = this.tableRows;
    if (this.isMassPORelease) {
      const {
        target: { scrollHeight, clientHeight, scrollTop },
      } = event;
      const bottomTolerance = 2;
      const isBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= bottomTolerance;
      const isLastPage = this.scrollPagination === this.scrollTotalPages;
      if (isBottom) {
        if (!isLastPage) this.scrollPagination += 1;
        this.handleMassive();
      }
    }
    }
  }

  handleMassive() {
    const searchResultsConfig = this.configData.searchResults[0];
    const isMassPORelease = searchResultsConfig?.isMassPORelease;
    this.isMassPORelease = isMassPORelease;

    if (isMassPORelease) {
      const maxRowsScroll = searchResultsConfig?.maxRowsScroll;
      const totalItems = this.tableRowsClone.length;
      this.scrollTotalPages = Math.ceil(totalItems / maxRowsScroll);
      const scrollItemsCalc = maxRowsScroll * this.scrollPagination;
      const itemsToShow = this.tableRowsClone.filter((row, index) => index + 1 <= scrollItemsCalc);

      this.tableRows = itemsToShow;
    }
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
          this.hide = true;
      }

    });
  }
  highlightColumnTabletView()
  {

	  let tdWidth = 0;
	  let index = 0;
	  this.configData.searchResults[0].TableHeaders.forEach(element => {
		index++;
		if(tdWidth >= ((screen.width)-250) && index <=  (this.configData.searchResults[0].TableHeaders.length - 2))
		{
			element.highlightInTabletView = false;
		}
		else
		{
			if(index > (this.configData.searchResults[0].TableHeaders.length - 2))
			{
				element.highlightInTabletView = true;
				if(element.primaryText.key=='Settings')
				{
					element.right='0px';
				}
				if(element.primaryText.key=='Actions' || element.primaryText.key=='select')
				{
					element.right='35px';
				}
			}
		}
	  });
	  this.tHeaders = this.configData.searchResults[0].TableHeaders;
  }

  toggleVisibility(hidden = !this.hide){
    this.hide = hidden;
  }

  // This storeSortingState function stores the sort information in sessionStorage
  storeSortingState(tHeaders,index,event){
    const action = new URLSearchParams(this.configData?.apiUrl?.split('?')[1] || '').get('action');
    if (!action) return;

    const sortingData = {
      tHeaders: JSON.stringify(tHeaders),
      index: index,
      event: JSON.stringify(event.map((ev: any) => ({ ...ev }))),
    };  
  
    sessionStorage.setItem(`sortingData-${action}`, JSON.stringify(sortingData));
  }
  // This function is being called from afterviewinit to call onPageSorting function with stored parameters, every time when user revisits the order listing page
  retrieveSortingState() {
    const action = new URLSearchParams(this.configData?.apiUrl?.split('?')[1] || '').get('action');
    if (!action) return;
  
    const storedData = sessionStorage.getItem(`sortingData-${action}`);
    if (!storedData) return;
  
    const { tHeaders, index, event } = JSON.parse(storedData);
    this.onPageSorting(JSON.parse(tHeaders), index, JSON.parse(event), new PointerEvent("click"));
}
  
  onPageSorting(tHeaders, index, event,e) {
  this.isTrusted = e.isTrusted // when onPageSorting function being called from afterviewinit there will be no click event, to ensure that this event is called from click or afterviewinit
    e.preventDefault();
    e.stopImmediatePropagation();
    this.selectionArray = [];
    this.dhlEventsDataObj= [];
    let sortKey;
    let ignoreApiCall = this.configData?.searchResults[0]?.ignoreApiCall ? false : true;
    if(this.configData.searchResults[0].showDefaultLoadMore== true && tHeaders.sortable && ignoreApiCall){
      if (tHeaders.sortColumnAttribute instanceof Object){
        this.sortKeyLoadMore = tHeaders.sortColumnAttribute.key;
        sortKey = tHeaders.sortColumnAttribute.key;

      }
      else {
        this.sortKeyLoadMore = tHeaders.sortColumnAttribute;
      }
      sortKey = this.sortKeyLoadMore;
      this.updateSortingModeLoadMore(sortKey, tHeaders, index, event);
      this.loadMoreSwitchColumn(event)
    }
    else {
      if (tHeaders.sortable) {
        let source = this.apiService._components[this.configData.name];
        if (source == undefined) {
          return
        }
        if (source.tHeaders == undefined) {
          return
        }
      // this.sortingKey = tHeaders.primaryText.value;
      this.sortingKey = tHeaders.sortColumnAttribute?.key ? tHeaders.sortColumnAttribute?.key : tHeaders.primaryText.value;
      console.log(this.sortingKey)
        // sortingMode might involve different fields, sortingKey might be an array
      Array.isArray(this.sortingKey) ? this.sortingKey.forEach(e => this.updateSortingMode(e,tHeaders,index,event)) : this.updateSortingMode(this.sortingKey,tHeaders,index,event);
    }}
  }

  updateSortingMode(sortingKey : string, tHeaders, index, event?: any) {
    // Initialize to DESC
    if(this.sortingMode != undefined && !this.sortingMode.hasOwnProperty(sortingKey) || this.sortingMode[sortingKey] === "") {
      this.sortingMode[sortingKey] = tHeaders.defaultSortMode || 'DESC'
      if (tHeaders.sortASC) {
        this.sortingMode[sortingKey] = "ASC"
      }
      if (tHeaders.sortDES) {
        this.sortingMode[sortingKey] = "DESC"
      }
    } else {
      // Switch the sortingMode from ASC to DESC and the other way around using SORTING ICONs
      this.sortingMode[sortingKey] = (this.sortingMode[sortingKey] === "ASC") ? "DESC" : "ASC";
    }
    // Switch the sortingMode from ASC to DESC and the other way around using SORTING ICONs
 //  this.sortingMode[sortingKey] = (this.sortingMode[sortingKey] === "ASC") ? "DESC" : "ASC";
    for (let item of this.tHeaders) {
      if(tHeaders.title == item.title){
        item.sortDefault = false;
        //START: SPRINT-28:CP-2812: Committing code changes related to sorting ICONs.
        if(this.sortingMode[sortingKey] === "DESC"){
          item.sortASC = false;
          item.sortDES = true;
        }if(this.sortingMode[sortingKey] === "ASC"){
          item.sortDES = false;
          item.sortASC = true;
        }
        //END: SPRINT-28:CP-2812: Committing code changes related to sorting ICONs.
      }else{
        item.sortDefault = true;
        item.sortASC = false;
        item.sortDES = false;
      }
    }
    this.updatePageSorting(sortingKey,tHeaders.sortColumnType,tHeaders,index,event)
  }

updatePageSorting(sortingKey: any,sortColumnType: string,tHeaders?: any, index?: any, event?: any) { // Called on OnPageSorting and table scroll 
    let target = this.apiService._components[this.configData.name].tableRows;
    // the below logic is to get the sorted order list, and make sure the data binded before page renders
    if (!target) {
        requestAnimationFrame(() => {
            this.updatePageSorting(sortingKey, tHeaders, sortColumnType, index, event);
        });
        return;
    }

    if(sortingKey) {
      // sortingKey.forEach(key => {
        let sortingMode = this.sortingMode[sortingKey]
        if (tHeaders.dataUploadSorting) {
          target.sort(this.compareValues(sortingKey, sortingMode,sortColumnType,tHeaders.dataUploadSorting));
        } else {
          target.sort(this.compareValues(sortingKey, sortingMode,sortColumnType));
      }
      // })
    }
    else{
      let sortingMode = this.sortingMode[" " + sortingKey]
      target.sort(this.compareValues(sortingKey, sortingMode,sortColumnType));
    }
    // below function call to store sorted info every time user clicks on sort icon
    if (this.isTrusted) { // this isTrusted makesure that storeSortingState is called only when user click on sort icon
        this.storeSortingState(tHeaders, index, event);
    }
}

  compareValues(key, order = 'asc',sortColumnType = undefined,title = false) { //compareValues in asc or desc order
    return function (a, b) {
      // if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      //   // sortingKey doesn't exist on none of the objects
      //   return 0;
      // }
      // Comparison of strings is done on uppercase
    //   let varA = (typeof a[key] === 'string') ?
    //     a[key].toUpperCase() : a[key];
    // let varB = (typeof b[key] === 'string') ?
    //     b[key].toUpperCase() : b[key];

      let varA;
      let varB;
      varA = a[key] ? a[key]: "";     // if its undefined or null or "" then assign ""
      varB = b[key] ? b[key]: "";

      varA = typeof varA === 'string' ? varA.toUpperCase(): varA;
      varB = typeof varB === 'string' ? varB.toUpperCase(): varB;

        // forcefully parsing to number since it fetching from OTM
      if(sortColumnType == 'number'){
        varA = +varA;
        varB = +varB;
      }
      // if date format is different
      if(sortColumnType == 'date'){
        if (title) {
          varA = parseDate(varA);
          varB = parseDate(varB);
        } else {
          varA = +new Date(varA);
          varB = +new Date(varB);
        } 
        varA = Number.isNaN(varA) ? 0: varA;
        varB = Number.isNaN(varB) ? 0: varB;
      }

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      else if (varA === varB) {
        comparison = 0;
      }
      return (
        (order.toLowerCase() == 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  updateSortingModeLoadMore(sortingKey : string, tHeaders, index,event){
    this.sortingModeLoadMore = (this.sortingModeLoadMore === "ASC") ? "DESC" : "ASC";
      for (let item of this.tHeaders) {
        if(tHeaders.title == item.title){
          localStorage.setItem('dynamicsortTitle', JSON.stringify(item.title));
          item.sortDefault = false;
          if(this.sortingModeLoadMore === "DESC"){
            item.sortDES = true;
            item.sortASC = false;
          }if(this.sortingModeLoadMore === "ASC"){
            item.sortASC = true;
            item.sortDES = false;
          }
        }else{
          item.sortDefault = true;
          item.sortASC = false;
          item.sortDES = false;
        }
      }
  }
  loadMore(event, e) {
    e.preventDefault();
    e.stopImmediatePropagation();
   this.isLoading = true;
   this.showLoadMoreLabel = false;
   this.pageNum = Number(this.pageNum);
   this.pageNum = this.pageNum + 1;
    for (let i = 0; i < event.length; i++) {
      if (event[i].name == 'loadmore') {
        let events = this.checkEventExist(event[i].events, 'LOAD_MORE');
        if (events) {
          let eventData: DhlFormControlEventData = {
            event: events.event,
            eventData: events,
            action: events.action,
            name: event,
            component: this,
            configData: this.configData,
            data: {
              pageNumber: this.pageNum,
              pageSize: this.pageSize,
              sortByColumnName: this.sortKeyLoadMore,
              sortingMode: this.sortingModeLoadMore,
            },
          }
           this.apiService._commonComponentSubject.next(eventData);
        }
      }
    }
  }

  loadMoreSwitchColumn(event) {
    this.pageNum = 0;
    for (let i = 0; i < event.length; i++) {
      if (event[i].name == 'loadmore') {
        let events = this.checkEventExist(event[i].events, 'LOAD_MORE');
        if (events) {
          let eventData: DhlFormControlEventData = {
            event: events.event,
            eventData: events,
            action: events.action,
            name: event,
            component: this,
            configData: this.configData,
            data: {
              pageNumber: this.pageNum,
              pageSize: this.pageSize,
              sortByColumnName: this.sortKeyLoadMore,
              sortingMode: this.sortingModeLoadMore,
            },
          }
        this.apiService._commonComponentSubject.next(eventData);
        }
      }
    }
  }

  getSortingParameters(sortByColumnName,sortingMode){
    if(this.configData.searchResults[0].showDefaultLoadMore== true &&  this.showLoadMore == true || this.configData.searchResults[0].showLoadMore== true){
      this.showLoadMoreLabel = true;
    }
    else{
      this.showLoadMoreLabel = false;
    }
      this.sortKeyLoadMore = sortByColumnName;
      this.sortingModeLoadMore = sortingMode;
      this.isLoading = false;

  }

  scrollTop(){
    const el = document.getElementById("TableListHeadRow");
    if (el && this.pageNum === 0 && !this.isSmallDevice) {
      const rect = el.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  ngOnDestroy() {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if(this.commonSubject){
      this.commonSubject.unsubscribe();
    }  
    if (this.valueChangesSub) {
      this.valueChangesSub.unsubscribe();
    }
  }

  selectMultipleRows(orderIds){
    this.tableRows.map(row => {
      for(let orderId of orderIds){
        if((row['orderId'] === orderId)){
          row.selected = true
        }
        else{

        }
      };
    }
    );
  }
  uncheckRows(orderIds, allids, event){
    this.similarSelected = false;
    this.tableRows.map(row => {

      for(let orderId of allids){

        if((row.selected)){
          row.selected = false;
        }

        let escalateTo = row['escalatedTo'] ? row['escalatedTo'] : "";

        if(row['orderId'] ===  orderId && event['matchcolumnValue'].indexOf(escalateTo.toLowerCase()) == -1){
          row.hidden = false;
          row.disabled = false;
        }

        if(row['verificationOngoing']){
          row.disabled = true;
          row.hidden = false;
        }

        if(row['verificationDate']){
          row.hidden = false;
          row.disabled = true;     
        }   

        if(event['matchcolumnValue'] && event['matchcolumnValue'].indexOf(row['status']) == -1){
          row.hidden = false;
          row.disabled = true;
        }
        if(row.escalatedTo == "escalate to client success team" || row.escalatedTo == "escalate to client" || row.escalatedTo == "escalate to operations"){
          row.hidden = false;
          row.disabled = true;
        }
      }
    })
  }
  hideRows(event, data){
    this.similarSelected = true;
    let businessObjectIds:any = [];
    // 13312 Order selection for verification - enhancement
    const isRepo = data.inventoryType?.toLowerCase() === 'repo';
    const matchingKeys = isRepo ? event.matchingKeyRepo : event.matchingKeyNonRepo;

    this.tableRows.map(row => {
      row.hidden = false;
      row.disabled = false;
    });

    let selectedRows:any = [];
    for(let matchKey of matchingKeys){
      if(selectedRows.length >= 20){
        break;
      }
      for(let row of this.tableRows){
        if(selectedRows.length >= 20){
          break;
        }
        if(selectedRows.includes(row)){
          continue;
        }
        // if(String(row[matchKey]) === String(data[matchKey])){
        if (row[matchKey] && data[matchKey] && String(row[matchKey]) === String(data[matchKey])){
          let result;
          if(event['matchcolumnValue']){
            result = event['matchcolumnValue'].indexOf(row[event['matchcolumnName']]);
            if(result !== -1 && row['escalatedTo']){
              result = event['matchcolumnValue'].indexOf(row['escalatedTo'].toLowerCase());
            }
            if(result !== -1 && row['verificationOngoing']){
              result = -1;
            }
            if(row['verificationDate']){
              result= -1;
            }
          }
          if(result === -1){
            continue;
          }
          selectedRows.push(row);
        }
      }
    }

    // hide all non-selected
    this.tableRows.map(row => {
      if(!selectedRows.includes(row)){
        row.hidden = true;
        row.disabled = true;
      }else{
        businessObjectIds.push(row);
      }
    });
    let eventData: DhlFormControlEventData = {
      event: event,
      eventData: this.tableRows,
      action: "SELECT SIMILAR",
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: businessObjectIds,
    }
    this.apiService._commonComponentSubject.next(eventData);
    // this.tableRows.map(row => {
    //   row.disabled = false;
    //   for(let key of event['matchingKey']){
    //     if((row[key] != data[key]) && data.selected ){
    //       row.disabled = true;
    //       break;
    //     }
    //   };
    // let result;
    // if(event['matchcolumnValue']){
    //   result = event['matchcolumnValue'].indexOf(row[event['matchcolumnName']]);
    // }
    // if(result == -1){
    //   row.disabled = true;
    // }
    // });
  }

  getFormattedData(tableHeaders, rowData, Textkey){
    if (tableHeaders?.formatResponse?.formatResponseType === "SYSTEM_DATE" && rowData[Textkey]) {
      try {
        const hasZ = rowData[Textkey].includes('Z');
        const dateValue = new Date(hasZ ? rowData[Textkey] : rowData[Textkey] + 'Z');
        const format = tableHeaders?.formatResponse?.formatFullDateTime
          ? (tableHeaders?.formatResponse?.shortYear ? 'MM/dd/yy HH:mm' : 'MM/dd/yyyy HH:mm')
          : (tableHeaders?.formatResponse?.shortYear ? 'MM/dd/yy' : 'MM/dd/yyyy');

        return this.datePipe.transform(dateValue, format);
      } catch (e) {
        console.log(e.message);
      }
    }else if(tableHeaders?.formatResponse?.shortYear && rowData[Textkey]){
      // CONDITION FOR ONLY shortYear (NO SYSTEM_DATE)
      try {
        return this.datePipe.transform(new Date(rowData[Textkey]), 'MM/dd/yy');
      } catch (e) {
        return;
      }
    }else if(tableHeaders?.formatResponse?.formatResponseType === "ACTUAL_DATE" && rowData[Textkey]){
      return moment.utc(rowData[Textkey]).format('MM/DD/YYYY');
    }else if(tableHeaders?.formatResponse?.formatResponseType === "DATE_MONTH_FORMAT" && rowData[Textkey]){
      return moment(rowData[Textkey] + 'Z').format('DD/MM/YYYY');
    }else if(tableHeaders?.textCaps){
      return rowData[Textkey]?.toUpperCase();
    }else if(tableHeaders?.currencyType == "dollar" && rowData[Textkey]){
      return "$"+rowData[Textkey];
    }else if(Textkey === "vehicleOperability"){
      return rowData[Textkey] ? "Operable" : "InOp" 
    }else if(Textkey === "verificationDate"){
      return rowData[Textkey] ? "" : "Unverified" 
    }else if(Textkey === "isHighValue"){
      return rowData[Textkey] ? "HVV" : "" 
    }else{
      return rowData[Textkey];
    }
  }

  getFormattedClass(rowData, Textkey){
    if(Textkey === "vehicleOperability"){
      return rowData[Textkey] ? "Operable" : "InOp" 
    }else if(Textkey === "isHighValue"){
      return rowData[Textkey] ? "HVV" : "" 
    }else if (Textkey === "verificationDate") {
        return rowData[Textkey] ? "" : "imageTextRed";
    }else{
      return '';
    }
  }

  getSystemDate(rowData, Textkey) {
    if (rowData[Textkey])
      return new Date(rowData[Textkey] + 'Z');
    else
      return '';
  }

  getColorClass(tableHeaders,rowData){
    if(tableHeaders?.colorCode){
      if(rowData[tableHeaders?.colorCode] < 2){
        return 'redColor'
      }else if((rowData[tableHeaders?.colorCode] < 5) && (rowData[tableHeaders?.colorCode] >= 2)){
        return 'brownColor'
      } else{
        return ''
      }
    }
  }

  ifColumnVisible(tableHeaders){
    if(tableHeaders?.editAccess && tableHeaders?.editAccess.length > 0){
      if(tableHeaders.editAccess[0].action === "hidden"){
        if(tableHeaders.editAccess[0].persona.indexOf(localStorage.getItem("userRole")) !== -1){
          return false;
        }else{
          return true;
        }
      }else{
        return true;
      }
    }else{
      return true;
    }
  }

  copyContent(e: any, th) {
    console.log(th);
    e.preventDefault();
    e.stopPropagation();
    let cellElement;
    if(th?.copyable === "currentDiv"){
      cellElement = e.target.closest('div');
    }else{
      cellElement = e.target.closest('td');
    }
    if (cellElement) {
      this.clipboard.copy(cellElement.textContent.trim());
      this._snackBar.open({ message: 'Text copied to clipboard' }, { duration: 4000 });
    }
  }

  //CP-5797 to display delivered and pickedup Date & Time
  getStatusWithSpace(item,status){
    if(item && item.STATUS === "Delivered" && item.deliveredDate){
      const deliveredLocal = this.apiService.getDateFormat(new Date(item.deliveredDate.toString()+" 00:00:00"))//CP-6447:Show just the date with no system time conversion when hovering on status
      item['statusWithSpace'] = status + "\n" + deliveredLocal;
    }else if (item && item.STATUS === "Picked Up" && item.pickedUpDate){
      const pickedupLocal = this.apiService.getDateFormat(new Date(item.pickedUpDate.toString()+" 00:00:00"))//CP-6447:Show just the date with no system time conversion when hovering on status
      item['statusWithSpace'] = status + "\n" + pickedupLocal;
    }else{
      item['statusWithSpace'] = status;
    }
  }
  //CP-5797 ends...

  index(index, item) {
    return (item && item._id) ? item._id : index;
  }
 }

 function parseDate(dateStr: string): number {
  //format : DD:MM:YYYY HH:MM Am/Pm
  if (!dateStr || typeof dateStr !== 'string') return NaN;

  const cleanStr = dateStr.trim();
  //format 1 : DD:MM:YYYY HH:MM Am/Pm
  const regex12h = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{1,2}):(\d{2}) ?([APMapm]{2})$/;
  //format 2 : MM-DD-YYYY HH:MM
  const regex24h = /^(\d{2})-(\d{2})-(\d{4}) (\d{1,2}):(\d{2})$/;
  //format 3 : DD/MM/YYYY HH:MM
  const regex24hDate_Time = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d)$/;

  let match: RegExpMatchArray | null = null;

  if ((match = cleanStr.match(regex12h))) {
    let [, dd, mm, yyyy, hour, minute, meridian] = match;
    const day: number = parseInt(dd, 10);
    const month: number = parseInt(mm, 10) - 1;
    let hr: number = parseInt(hour, 10);
    const min: number = parseInt(minute, 10);
    meridian = meridian.toUpperCase();

    if (meridian === 'PM' && hr < 12) hr += 12;
    if (meridian === 'AM' && hr === 12) hr = 0;
    return new Date(parseInt(yyyy, 10), month, day, hr, min).getTime();
  } else if ((match = cleanStr.match(regex24h))) {
    let [, mm, dd, yyyy, hour, minute] = match;
    const day: number = parseInt(dd, 10);
    const month: number = parseInt(mm, 10) - 1;
    let hr: number = parseInt(hour, 10);
    const min: number = parseInt(minute, 10);
    return new Date(parseInt(yyyy, 10), month, day, hr, min).getTime();
  }  else if ((match = cleanStr.match(regex24hDate_Time))) {
    // New format: DD/MM/YYYY HH:MM
    let [, dd, mm, yyyy, hour, minute] = match;
    const day: number = parseInt(dd, 10);
    const month: number = parseInt(mm, 10) - 1; // Month is 0-indexed in JavaScript Date
    let hr: number = parseInt(hour, 10);
    const min: number = parseInt(minute, 10);
    return new Date(parseInt(yyyy, 10), month, day, hr, min).getTime();
  }
  return NaN;
}
